/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */

/** Logo images, generated from the files in frontend/branding with `just icons` */
const LOGO_IMAGE_URL = '/icons/logo.png'
const SMALL_LOGO_IMAGE_URL = '/icons/logo-small.png'

/** Logos up to this height in CSS pixels use the pixel art, which is 64px and therefore sharp on high density screens */
const SMALL_LOGO_MAX_HEIGHT = 32

/**
 * Returns the logo image that is best readable at the given height.
 * Small logos use hand-drawn pixel art, because the detailed logo turns blurry when it is scaled down that much.
 *
 * @param height The height of the logo in CSS pixels
 * @return The URL of the logo image
 */
export const getLogoImageUrl = (height: number): string =>
  height <= SMALL_LOGO_MAX_HEIGHT ? SMALL_LOGO_IMAGE_URL : LOGO_IMAGE_URL
